import * as Business      from '../../business';
import { usePageContext } from '../../components/render_page';
import PhoneIcon          from '../phone_icon.svg';
import React              from 'react';


export default function MessagePreview({ campaign }) {
  return (
    <div className="block message-preview">
      <div className="underline-header">
        <h4>Email Preview</h4>
      </div>
      <div className="block-content">
        <Message {...{ campaign }}/>
      </div>
    </div>
  );
}


function Message({ campaign }) {
  const { businessID } = usePageContext();
  const business       = Business.useBusiness(businessID);
  const bannerImage    = Business.useBannerImage(businessID);

  const lines = campaign.body.split('\n').filter(item => item.trim());

  return (
    <div className="preview-box">
      <div className="subject">
        {campaign.subject}
      </div>
      <div className="preview-content">
        <img src={bannerImage} className="banner-image"/>
        <div className="preview-text">
          <p>Hello,</p>
          <div className="body">
            {lines.map((line, i) => <p key={i}>{line}</p>)}
          </div>
          <CtaSection/>
          <BusinessAddress {...{ business }}/>
          <MessageFooter/>
        </div>
      </div>
    </div>
  );
}


function CtaSection() {
  return (
    <div className="cta-section">
      <p className="cta">
        <span className="cta-button">
          <PhoneIcon/>
          Call us today
        </span>
      </p>

      <p>
        You can <span className="link">call us</span>, reply to this email, or <span className="link">visit our website</span> for more information.
      </p>
    </div>
  );
}


function BusinessAddress({ business }) {
  if (!business)
    return null;

  const { name }                = business;
  const { contact }             = business;
  const { street, city, state } = contact;
  return (
    <p className="address">
      {name}<br/>
      {street}<br/>
      {city}, {state}
    </p>
  );
}


function MessageFooter() {
  return (
    <p className="footer">
      To stop receiving emails from us, you can <span className="link">unsubscribe</span>.
    </p>
  );
}
